import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const SCENARIO_CAPTIONS = {
  BLUE_SKY: "Normal Operating Conditions",
  GRAY_SKY: "Storm — Non-EOP Conditions",
  BLACK_SKY: "Hurricane — EOP Activated",
  BEYOND_BLACK_SKY: "Severe Storm Conditions",
};

export const useAppStore = create(
  persist(
    (set) => ({
      scenario: "BEYOND_BLACK_SKY",
      setScenario: (scenario) => set({ scenario }),

      filters: {},
      setFilter: (key, value) =>
        set((s) => {
          const filters = { ...s.filters };
          if (value === null || value === undefined || value === "" || value === "all") delete filters[key];
          else filters[key] = value;
          return { filters };
        }),
      clearFilters: () => set({ filters: {} }),

      // "How is this calculated?" modal
      explainTarget: null, // { type, id, name, title }
      openExplain: (target) => set({ explainTarget: target }),
      closeExplain: () => set({ explainTarget: null }),
    }),
    {
      name: "tmo-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({ scenario: s.scenario, filters: s.filters }),
    }
  )
);
